import { render } from "./PrivacyNotice.vue?vue&type=template&id=d82718a2"
import script from "./PrivacyNotice.vue?vue&type=script&lang=js"
export * from "./PrivacyNotice.vue?vue&type=script&lang=js"

import "./PrivacyNotice.vue?vue&type=style&index=0&id=d82718a2&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__